import { Injectable } from '@angular/core';

declare var gtag : any;

export interface GTagEvent {
    eventName: string;
    eventCategory: string;
    eventDetails: string;
}

export const ANALYTICS_EVENTS : Record<string,GTagEvent> = {
    "COOKIES": {
        eventName: "COOKIES",
        eventCategory: "Cookies",
        eventDetails: "Cookies accepted, rejected or individually selected: "
    },
    "COOKIEPOLICY": {
        eventName: "COOKIEPOLICY",
        eventCategory: "Policy",
        eventDetails: "Viewed cookies policy"
    },
    "PRIVACYPOLICY": {
        eventName: "PRIVACYPOLICY",
        eventCategory: "Policy",
        eventDetails: "Viewed privacy policy"
    },
    "LICENSING": {
        eventName: "LICENSING",
        eventCategory: "Policy",
        eventDetails: "Viewed licensing page"
    },
    "ALBUMS_SCROLL_DOWN": {
        eventName: "ALBUMS_SCROLL_DOWN",
        eventCategory: "Navigation",
        eventDetails: "Scrolled down"
    },
    "SCROLLED_TO_END": {
        eventName: "SCROLLED_TO_END",
        eventCategory: "Navigation",
        eventDetails: "Scrolled to end"
    },
    "ALBUM_SEARCH": {
        eventName: "ALBUM_SEARCH",
        eventCategory: "Navigation",
        eventDetails: "Searched albums, term: "
    },
    "PREVIEW_HOVER": {
        eventName: "PREVIEW_HOVER",
        eventCategory: "Navigation",
        eventDetails: "Hovered on album: "
    },
    "ALBUM_CLICKED": {
        eventName: "ALBUM_CLICKED",
        eventCategory: "Navigation",
        eventDetails: "Clicked album, id: "
    },
    "SO_ME_BUTTON_CLICKED": {
        eventName: "SO_ME_BUTTON_CLICKED",
        eventCategory: "Navigation",
        eventDetails: "Clicked: "
    },
}

export const COOKIES = 'COOKIES';

@Injectable({providedIn: 'root'})
export class AnalyticsService {

    track( event: GTagEvent, additionalDetails: any ) {
        // console.log( event );
        // console.log( additionalDetails );
        try {
            gtag('event', event.eventName, {
                // event Type - example: 'SCROLL_TO_TOP_CLICKED'
                'event_category': event.eventCategory,

                // the label that will show up in the dashboard as the events name
                'event_label': event.eventName,

                // a short description of what happened
                'value': additionalDetails
            });
        } catch( error ) {
            console.error( error );
            // Analytics failed, likely cookie rejection
        }
    }
}
